<template>
  <div id="concepts-app">
    <router-view/>    
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
